<template>
  <div class="app" >
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/dashboard">
        <img class="navbar-brand-full" src="/ui/img/logo/logo-F1RuleServer.png" width="135" height="30" alt="F1RuleServer Logo">
        <img class="navbar-brand-minimized" src="/ui/img/logo/logo-f1.png" width="33" height="30" alt="F1 Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item class="d-md-down-none">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger">5</b-badge>
        </b-nav-item> -->
        <!-- <DefaultHeaderDropdownAccnt /> -->
        <div style="padding:5px"><img src="/ui/img/user-icon.png" width="17" height="17" alt="user image" padding="10"></div>
        [{{ auth.profile.username }}]
        <!-- <b-nav-item @click="toggle" style="margin-right: 25px;" class="d-none d-sm-block">
          <i class="fa fa-clock-o" :class="{ 'text-secondary' : pause }" title="toggle auto logout"></i>
          <b-badge v-if="stale" pill :variant="pause ? 'secondary' : 'success'" >{{stale}}</b-badge>
        </b-nav-item> -->
        <b-button class="ml-2 mr-3 btn-sm" variant="primary" @click="logout()" >
          <i class="fa fa-sign-out" stitle="logout" @click="logout()"><small><b>LOGOUT</b></small></i>
        </b-button>
      </b-navbar-nav>

    </AppHeader>
    <div class="app-body pull-right" >
      <AppSidebar fixed ref="_list">
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"> </SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>

      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <div>
        <a href="http://www.f1security.co.kr">F1Security Inc.</a>
        <span>128, Gasan digital 1-ro, Geumcheon-gu, Seoul, Republic of Korea</span>
      </div>
      <div class="ml-auto">
        <span>Copyright 2019. F1Security Inc. All right reserved.</span>
      </div>
    </TheFooter>
  </div>
</template>


<script>
// import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import { auth, idle } from '@/f1/service';
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import * as _ from 'lodash'

let all_nav =  [
  // 패턴 및 배포 현황
  { name: 'Dashboard', url: '/dashboard', icon: 'cui-dashboard', permission: 'Master,User' },

  { name: 'Connector', title : true, permission: 'Master,User'},
  { name: 'C-TAS', url: '/connector/ctas', icon: 'fa fa-list-alt', permission: 'Master,User'},
  { name: 'Webshell', url: '/connector/webshell', icon: 'fa fa-list-alt', permission: 'Master,User'},
  // { name: 'CTI', url: '/connector/cti', icon: 'fa fa-list-alt', permission: 'Master,User'}, // cti 준비되면 오픈

  { name: 'UWSS', title : true, permission: 'Master,User,License'},
  { name: 'CRS', url: '/uwss/crs', icon: 'fa fa-list-alt', permission: 'Master,User'},
  { name: 'Pattern', url: '/uwss/pattern', icon: 'fa fa-list-alt', permission: 'Master,User'},
  { name: 'Webshell', url: '/uwss/webshell', icon: 'fa fa-id-card-o', permission: 'Master,User' },
  { name: 'License', url: '/uwss/license', icon: 'fa fa-id-card-o', permission: 'Master,User,License' },

  { name: 'Audit', title : true, permission: 'Master'},
  { icon: 'fa fa-list-ul', name: 'Log', permission: 'Master', children: [
    { name: 'Login', url: '/logs/login', icon: 'fa fa-sign-in', permission: 'Master' },
    // { name: 'System', url: '/logs/system', icon: 'fa fa-cogs', permission: 'Master' },
    {
      name: 'Agent', url: '/logs/agent', icon: 'fa fa-repeat', permission: 'Master',
      badge: { variant: 'primary', text: 'UWSS' }
    },
  ]},

  { name: 'ETC', title : true, permission: 'Master,User,License'},
  { name: 'User', url: '/system/user', icon: 'fa fa-users', permission: 'Master'},
  { name: 'Profile', url: '/profile', icon: 'fa fa-user-circle-o', permission: 'Master,User,License' },


  //  TODO : 향후 사용 고려 필요
  // { name: 'Board', title : true, permission: 'Master,User' },
  // { name: 'Notice', url: '/boards/notice', icon: 'fa fa-bullhorn', permission: 'Master,User' },
]

let check_permit = vs => _.filter(vs, v => {
  if(!auth.has_permission(v.permission)) { return undefined; }
  if(_.isArray(v.children)) { v.children = check_permit(v.children); }
  return v;
});
// all_nav = check_permit(all_nav);

export default {
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  // data: () => ({ nav: check_permit(links), pause: false, stale: undefined, stale_check : undefined }),
  data: () => {
    return {
    auth,
    nav: check_permit(all_nav),
    base_href : `${location.protocol}//${location.host}`,
    b : undefined,
    pause: false,
    location : '',
    service : '',
    stale: undefined,
    stale_check : undefined,
    }
  },
  computed: {
    badge() { return { variant: 'primary', text: 'NEW' } },
    name() { return this.$route.name },
    list() { return this.$route.matched },
  },
  methods: {
    toggle() { this.pause = !this.pause; this.pause ? idle.pause() : idle.resume(); },
    logout() { auth.logout(); this.$router.push('/login') },
    dd() { return location.hash.split('/')[1] },
    close() {
      let els = document.getElementsByClassName('nav-item nav-dropdown router-link-exact-active open active')
      for (let i = 0; i < els.length; i++) {
        els[i].classList.remove("open")
      }
      // console.log('els', els)
    }
  },
  created: function() {
    console.log('[vue] private container', 'created');

    idle.start(this.logout, 1440) // 24 시간 (min)
      .keepalive(auth.refresh, 300); // 5 분 (sec)
    this.stale_check = setInterval(() => {
      if(idle.p) { return this.stale = '∞'; }
      let ts = parseInt((idle.stale - new Date().getTime()) / 1000);
      if(ts > 300) { return this.stale = '+5:00'; } // 5분 이내는 신경쓰지 않음.
      let m = (parseInt(ts / 60)).toString();
      let s = (parseInt(ts % 60) + 100).toString().substr(1,2);
      return this.stale = `${m}:${s}`;
    }, 1000);
  },
  destroyed: function() {
    console.log('[vue] private container', 'destroyed');
    idle.stop();
    clearInterval(this.stale_check);
  },
  mounted: function() { console.log('[vue] private container', 'mounted'); this.close() },
}
</script>
